import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import getTotalListings from 'src/common/utils/getTotalListings';
import Typography from 'src/common/components/Typography';
import styles from './PaginationAndListingsCount.module.scss';

export type PaginationAndListingsCountProps = {
  limit?: number;
  count?: number;
  page?: number | null;
};

const PaginationAndListingsCount: FC<PaginationAndListingsCountProps> = ({
  limit,
  count,
  page,
}) => {
  const [t] = useTranslation('search-page');

  if (!count || !limit) return null;

  const from = page || 1;
  const totalPages = Math.ceil(count / limit);
  const to = totalPages;
  const total = getTotalListings(count);

  return (
    <div className={styles.root}>
      <Typography
        type="p"
        size="body-m"
      >
        {t('breadcrumbs--pagination', { from, to, total })}
        {' • '}
        {t('breadcrumbs--listings-count', { count })}
      </Typography>
    </div>

  );
};

export default PaginationAndListingsCount;
